export const ASC = "ASC";
export const DESC = "DESC";
export const NO_DIRECTION = "NONE";
//# sourceMappingURL=DatatableTypes.js.map